import { useMutation } from 'Data/Api.js'
import { useDataValue } from 'Simple/Data.js'
import { useSetFlowTo, normalizePath } from 'Simple/Flow.js'
import mutation from './mutation.graphql.js'
import { textInput } from 'Data/validate.js'

export default function useDataOnSubmit(props) {
  let patient_id = useDataValue({
    context: 'patient',
    path: 'id',
    viewPath: props.viewPath,
  })
  let parent_id = useDataValue({
    context: 'patient_documents',
    path: 'parent_id',
    viewPath: props.viewPath,
  })
  let setFlowTo = useSetFlowTo(props.viewPath)
  let [, executeMutation] = useMutation(mutation)

  return async function onSubmit({ value }) {
    if (!textInput(value.name)) return true

    let mutationResponse = await executeMutation({
      name: value.name,
      patient_id,
      parent_id,
    })
    if (mutationResponse.error) {
      throw mutationResponse.error
    }
    setFlowTo(normalizePath(props.viewPath, '../No'))
  }
}
